import type { WorkspaceRow } from './workspace';
import type { FolderOption } from '@utils/folders/folder-tree';

export const WORKSPACE_DRAG_TYPE = 'application/x-scriptix-workspace';

export function rowKey(row: WorkspaceRow) {
  return `${row.variant}:${row.id}`;
}

export function getDraggedRows(row: WorkspaceRow, selection: WorkspaceRow[]) {
  return selection.some(selected => rowKey(selected) === rowKey(row))
    ? selection
    : [row];
}

export function canMoveRows(
  rows: WorkspaceRow[],
  targetId: number | null,
  currentFolderId: number | null,
  folders: FolderOption[] | undefined
) {
  if (!rows.length || targetId === currentFolderId) return false;
  const target = folders?.find(option => option.folder.id === targetId);
  return rows.every(row => {
    if (!row.id) return false;
    if (row.variant !== 'folder') return true;
    const id = Number(row.id);
    if (id === targetId || row.parent_id === targetId) return false;
    // Until the complete tree is available, refuse folder moves rather than
    // risk sending a request that would create a cycle.
    if (!folders) return false;
    return targetId === null || (!!target && !target.ancestorIds.includes(id));
  });
}
